import React, { useEffect, useCallback, useState } from 'react'
import { SimpleSubTitleCard, SimpleTitleCard } from 'styles/global'
import { ButtonConfigKanban } from '../../style'
import { AiOutlinePlusCircle } from 'react-icons/ai'
import { Card, Col, Row } from 'reactstrap'
import InputCustom from 'components/Inputs'
import useRedux from 'hooks/useRedux'
import { useSelector } from 'react-redux'
import { ApplicationState } from 'store'
import { CONFIGURACAO_KANBAN } from 'store/modules/backoffice/configuracaoKanban/types'
import * as configuracaoKanbanActions from 'store/modules/backoffice/configuracaoKanban/actions'
import ModalRegister from './ModalRegister'
import CustomTable from 'components/CustomTable'
import { getPipelineColumns } from '../../constants/columns'
import ModalExclusao from 'components/ModalExclusao'
import PrivateComponent from 'components/PrivateComponent'

const Pipelines = () => {
  const { tabPipelines, activeTab } = useSelector<
    ApplicationState,
    CONFIGURACAO_KANBAN
  >((state) => state.configuracaoKanban)

  const { dispatch } = useRedux()

  const [selectedId, setSelectedId] = useState('')

  const novoPipeline = () => {
    dispatch(configuracaoKanbanActions.setModalRegisterIsOpenTabPipelines(true))
    dispatch(configuracaoKanbanActions.setPipelineSelecionadoTabPipelines(null))
    dispatch(configuracaoKanbanActions.cleanInvalidsRegisterTabPipelines())
    dispatch(
      configuracaoKanbanActions.setRegisterTabPipelines({
        id: '',
        nomePipeline: '',
        descricao: '',
        centroCustoId: '',
        quantidadeLeads: undefined,
        site: false
      })
    )
  }

  const getPipelines = useCallback(() => {
    dispatch(configuracaoKanbanActions.getPipelinesTabPipelinesSaga())
  }, [dispatch])

  function setPage(value: number) {
    dispatch(configuracaoKanbanActions.setPaginationTabPipelines(value, 'page'))
    dispatch(configuracaoKanbanActions.getPipelinesTabPipelinesSaga())
  }

  function setPageSize(value: number) {
    dispatch(configuracaoKanbanActions.setPaginationTabPipelines(0, 'page'))
    dispatch(
      configuracaoKanbanActions.setPaginationTabPipelines(value, 'pageSize')
    )
    dispatch(configuracaoKanbanActions.getPipelinesTabPipelinesSaga())
  }

  useEffect(() => {
    if (activeTab === 0) {
      getPipelines()
    }
  }, [getPipelines, activeTab])

  const COLUMNS = getPipelineColumns({
    onView: (row) => {
      dispatch(
        configuracaoKanbanActions.setModalRegisterIsOpenTabPipelines(true)
      )
      dispatch(
        configuracaoKanbanActions.setPipelineSelecionadoTabPipelines(row.id)
      )
      dispatch(configuracaoKanbanActions.setVisualizacaoTabPipelines(true))
    },
    onEdit: (row) => {
      dispatch(
        configuracaoKanbanActions.setModalRegisterIsOpenTabPipelines(true)
      )
      dispatch(
        configuracaoKanbanActions.setPipelineSelecionadoTabPipelines(row.id)
      )
    },
    onToggleStatus: (row) => {
      dispatch(
        configuracaoKanbanActions.alterarStatusPipelineTabPipelinesSaga(
          row.id,
          !row.status
        )
      )
    },
    onDuplicate: (row) => {
      dispatch(
        configuracaoKanbanActions.duplicarPipelineTabPipelinesSaga(row.id)
      )
    },
    onDelete: (row) => {
      setSelectedId(row.id)
    }
  })

  const alteraStatusPesquisa = useCallback(
    (value: CONFIGURACAO_KANBAN['tabPipelines']['search']['status']) => {
      dispatch(configuracaoKanbanActions.setSearchTabPipelines(value, 'status'))
      dispatch(configuracaoKanbanActions.getPipelinesTabPipelinesSaga())
    },
    [dispatch]
  )

  return (
    <div className="d-flex flex-column">
      <div className="d-flex justify-content-between align-items-start">
        <div>
          <SimpleTitleCard className="pb-0">
            Gerenciar Pipelines
          </SimpleTitleCard>
          <SimpleSubTitleCard>
            Crie, edite e organize seus pipelines de vendas
          </SimpleSubTitleCard>
        </div>
        <PrivateComponent screen="configuracaoKanban" typeActions="gravar">
          <div className="gap-2">
            <ButtonConfigKanban
              className="btn-blue"
              onClick={() => {
                novoPipeline()
              }}
            >
              <AiOutlinePlusCircle />
              <span>Novo Pipeline</span>
            </ButtonConfigKanban>
          </div>
        </PrivateComponent>
      </div>
      <Row className="d-flex row-gap-20">
        <Col md={12}>
          <Card className="d-flex flex-column gap-2 p-3 mt-3 w-100">
            <div className="d-flex flex-row gap-3 align-items-center w-100">
              <div className="flex-grow-1">
                <InputCustom
                  placeholder="Buscar pipelines"
                  onChange={(e) => {
                    dispatch(
                      configuracaoKanbanActions.setSearchTabPipelines(
                        e.target.value,
                        'nome'
                      )
                    )
                  }}
                  value={tabPipelines.search.nome}
                />
              </div>
              <ButtonConfigKanban
                className="btn-light"
                onClick={() => {
                  alteraStatusPesquisa(null)
                }}
                active={tabPipelines.search.status === null}
              >
                <span>TODOS</span>
              </ButtonConfigKanban>
              <ButtonConfigKanban
                className="btn-light"
                onClick={() => {
                  alteraStatusPesquisa(true)
                }}
                active={tabPipelines.search.status === true}
              >
                <span>ATIVOS</span>
              </ButtonConfigKanban>
              <ButtonConfigKanban
                className="btn-light"
                onClick={() => {
                  alteraStatusPesquisa(false)
                }}
                active={tabPipelines.search.status === false}
              >
                <span>INATIVOS</span>
              </ButtonConfigKanban>
            </div>
            <div className="d-flex gap-3">
              <div className="d-flex flex-wrap">
                <ButtonConfigKanban
                  className="btn-blue justify-content-center"
                  onClick={getPipelines}
                  width={180}
                >
                  <span>Pesquisar</span>
                </ButtonConfigKanban>
              </div>
              <div className="d-flex">
                <ButtonConfigKanban
                  className="btn-light justify-content-center"
                  onClick={() => {
                    dispatch(
                      configuracaoKanbanActions.cleanSearchTabPipelines()
                    )
                    getPipelines()
                  }}
                  width={180}
                >
                  <span>Limpar</span>
                </ButtonConfigKanban>
              </div>
            </div>
          </Card>
        </Col>
        <Col md={12}>
          <CustomTable
            data={tabPipelines.pipelines}
            columns={COLUMNS}
            page={tabPipelines.pagination.page}
            pageSize={tabPipelines.pagination.pageSize}
            rowCount={tabPipelines.pagination.totalRegistros || 0}
            setPage={(e) => {
              setPage(e)
            }}
            setPageSize={(e) => {
              setPageSize(e)
            }}
            getRowHeight={() => 'auto'}
            autoHeight
          />
        </Col>
      </Row>
      <ModalRegister
        isOpen={tabPipelines.modalRegisterIsOpen}
        toggle={() => {
          dispatch(
            configuracaoKanbanActions.setModalRegisterIsOpenTabPipelines(false)
          )
          dispatch(configuracaoKanbanActions.setVisualizacaoTabPipelines(false))
        }}
      />
      <ModalExclusao
        isOpen={!!selectedId}
        toggle={() => {
          setSelectedId('')
        }}
        onRemove={() => {
          dispatch(
            configuracaoKanbanActions.removerPipelineTabPipelinesSaga(
              selectedId
            )
          )
          setSelectedId('')
        }}
        customMessage="Deseja realmente excluir este pipeline?"
      />
    </div>
  )
}

export default Pipelines
